import React from 'react';
import NavigationMenu from '../NavigationMenu.jsx';

/**
 * HUD action bar (v3 `.btn-bar`). Real handlers from App. ch6 reconciles NAV with
 * CinematicStage's internal nav (chromeless split) and adds the glass panels.
 *
 * Visual parity with the v3 reference (`DeadSignalHUD.jsx` .btn-bar):
 *   BEGIN INTV / END INTV (amber toggle) · NAV · AUDIO · EVD LOCKER (amber) ·
 *   spacer · EVALS (phosphor toggle) · EXIT (red)
 *
 * Props (presentational wiring — contract preserved):
 *   interviewActive    bool   — amber toggle on the BEGIN/END INTV button
 *   onToggleInterview  fn     — BEGIN/END INTV click
 *   onNav              fn?    — NAV click (optional; lead wires it. If undefined,
 *                              the button renders disabled/dimmed and does nothing)
 *   onAudio            fn     — AUDIO click
 *   onEvidence         fn     — EVD LOCKER click
 *   onEvals            fn     — EVALS click
 *   evalsOpen          bool   — phosphor `.on` state for EVALS
 *   onExit             fn     — EXIT click
 */
export default function HudButtonBar({
  interviewActive,
  canInterview,
  onToggleInterview,
  onNav,
  onAudio,
  onEvidence,
  onEvals,
  evalsOpen,
  onExit,
}) {
  // The BEGIN/END INTV control only belongs in scenes with an interviewable NPC
  // (scene.interview). Outside those scenes there is no one to interview, so the
  // button is hidden rather than dangling. An active interview always keeps END
  // INTV available (defensive — you can always step out).
  const showInterviewBtn = canInterview || interviewActive;
  return (
    <div className="btn-bar">
      {showInterviewBtn && (
        <button
          className={'hb ' + (interviewActive ? 'am-on' : 'am')}
          onClick={onToggleInterview}
        >
          {interviewActive ? 'END INTV' : 'BEGIN INTV'}
        </button>
      )}

      <NavigationMenu onNavigate={onNav} />

      <button className="hb" onClick={onAudio}>
        AUDIO
      </button>

      <button className="hb am" onClick={onEvidence}>
        EVD LOCKER
      </button>

      <div className="hb-sep" />

      <button
        className={'hb' + (evalsOpen ? ' on' : '')}
        onClick={onEvals}
      >
        EVALS
      </button>

      <button className="hb rd" onClick={onExit}>
        END GAME
      </button>
    </div>
  );
}
